(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.countdown-timer[data-target-date]').forEach(function (el) {
      var target = new Date(el.dataset.targetDate).getTime();
      if (isNaN(target)) return;
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function pad(n) { return String(n).padStart(2, '0'); }

      function markUpdated(node) {
        if (!node || prefersReducedMotion) return;

        var unit = node.closest('.countdown-timer__unit');
        node.classList.remove('is-updating');
        if (unit) unit.classList.remove('is-updating');

        window.requestAnimationFrame(function () {
          node.classList.add('is-updating');
          if (unit) unit.classList.add('is-updating');
        });

        window.clearTimeout(node._countdownTickTimeout);
        node._countdownTickTimeout = window.setTimeout(function () {
          node.classList.remove('is-updating');
          if (unit) unit.classList.remove('is-updating');
        }, 440);
      }

      function setValue(node, value, animate) {
        if (!node || node.textContent === value) return;
        node.textContent = value;
        if (animate) markUpdated(node);
      }

      var hasRendered = false;

      function update() {
        var diff = Math.max(0, target - Date.now());
        var days = el.querySelector('[data-countdown="days"]');
        var hours = el.querySelector('[data-countdown="hours"]');
        var minutes = el.querySelector('[data-countdown="minutes"]');
        var seconds = el.querySelector('[data-countdown="seconds"]');

        setValue(days, pad(Math.floor(diff / 86400000)), hasRendered);
        setValue(hours, pad(Math.floor((diff % 86400000) / 3600000)), hasRendered);
        setValue(minutes, pad(Math.floor((diff % 3600000) / 60000)), hasRendered);
        setValue(seconds, pad(Math.floor((diff % 60000) / 1000)), hasRendered);

        hasRendered = true;
      }

      update();
      setInterval(update, 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
